// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"LandingPageGrid-5be450f9fbc1ee18","cell":"LandingPageGrid-bf351640b41b6fb9"};